const TopicStatus = Object.freeze({
  ACTIVE: 'Active',
  BUILDING: 'Building',
  STANDBY: 'Standby',
  AUDIENCE_BUILDING: 'AudienceBuilding'
})
export default TopicStatus
// RESERVE BELOW
